/*
    Action:     Output dynamic date selector
    Original:   ---
                https://github.com/akiran/react-slick cut down version of this slider functionality
    Orginator:  ben.hobden@espn.com
    Returns:    The JavaScript date iobject in the callback function
*/

import React from 'react'
import DatePicker from './DatePicker.jsx'
import dateFormat from '../../lib/utils/dateformat'
import createReactClass from 'create-react-class'

var DateSlider = createReactClass({

  displayName: 'DateSelect',

  mixins: [ dateFormat ],

  getInitialState: function () {
    var iDayRange   = 7
    var iItemWidth  = 36
    var maxWidthMedium = 768

    /*
      Below condition checks for screen size and initialize iDayRange and iItemWidth
      based on that. For mobile < 768 iItemWidth is fixed to 40px
    */
    if(process.browser && screen && 'width' in screen && screen.width < maxWidthMedium) {
      iDayRange = 5
      iItemWidth = 40
    }

    var iStartPos   = 0-(iDayRange*iItemWidth)
    return {
      activeDate:     null,
      displayDate:    null,
      oneDay:         86400000,  // 1 day in milliseconds
      dayRange:       iDayRange,
      itemWidth:      iItemWidth,
      touchObject: {
        startX: null,
        startY: null,
        curX:   null,
        curY:   null,
        swipeLength: null
      },
      didSwipe:       false,
      dragging:       false,
      animate:        false,
      currentPos:     iStartPos,
      touchSliderMove:iStartPos
    }

  },

  /**
  * Intial load so add the date to the state for use and manipulation
  * @returns {undefined} undefined
  **/
  componentWillMount: function () {
    let date = this.props.date
    if( !date ) {
      date = new Date()
      date = date.toISOString()
    }
    var oDate       = this.dateToObject( date ) || new Date()
    var iDate       = oDate.setHours(0,0,0,0)
    this.setState({
      activeDate:     iDate,
      displayDate:    iDate
    })
  },

  /**
  * Reset state if date has changed
  *
  * @param {Object} nextProps Props
  * @returns {undefined} undefined
  **/
  componentWillReceiveProps: function (nextProps) {
    var oDate           = this.dateToObject(nextProps.date) || new Date()
    var iDate           = oDate.setHours(0,0,0,0)
    if(nextProps.date !== this.props.date) {
      this.animateToDate(iDate)
      this.setState({
        activeDate: iDate,
        didSwipe: false
      })
    }
  },

  /**
  * Captures the date of the node clicked and sets the state to that. If
  * a swipe was tracked the click is ignored and the swipe tracker reset
  *
  * @param {Number} iDate date
  * @param {Number} iItemPos position index
  * @param {Object} e Event
  * @returns {undefined} undefined
  **/
  selectDate: function (iDate, iItemPos, e) {
    if(e && e.stopPropagation) {
      e.stopPropagation()
    }
    if(e && e.preventDefault) {
      e.preventDefault()
    }
    iDate = (typeof iDate === 'object') ? iDate.setHours(0,0,0,0) : iDate
    if(typeof this.state.touchObject.swipeLength !== 'number') {
      this.setState({
        activeDate: iDate
      })
      this.animateToDate(iDate)
      this.dateSelected(iDate)
    }
  },

  /**
  * Subtracts 7 days from the current date and then forces a redraw
  * @returns {undefined} undefined
  **/
  previous: function () {
    var iNewDate    = this.state.displayDate - (this.state.oneDay * this.state.dayRange)
    this.animateToDate(iNewDate)
  },

  /**
  * Adds 7 days to the current date and then forces a redraw
  * @returns {undefined} undefined
  **/
  next: function () {
    var iNewDate    = this.state.displayDate + (this.state.oneDay * this.state.dayRange)
    this.animateToDate(iNewDate)
  },

  /**
  * Redraws the page to last know good state
  * @returns {undefined} undefined
  **/
  reset: function () {
    this.setState({})
  },

  /**
  * Capture the start position of the mouse/touch so that we can
  * determine the direction and size of the interaction later.
  *
  * @param {Object} e event object
  * @returns {undefined} undefined
  **/
  swipeStart: function (e) {

    var posX, posY

    posX = (e.touches !== undefined) ? e.touches[0].pageX : e.clientX
    posY = (e.touches !== undefined) ? e.touches[0].pageY : e.clientY

    this.setState({
      dragging: true,
      touchObject: {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      }
    })

    // e.preventDefault()
  },

  /**
  * Captures the current mouse/finger movement and stores the value to
  * allow the position of the slider to be updated.
  *
  * @param {Object} e event object
  * @returns {undefined} undefined
  **/
  swipeMove: function (e) {

    if (!this.state.dragging) {
      return
    }

    var touchObject = this.state.touchObject

    var iCurrX = (e.touches) ? e.touches[0].pageX : e.clientX
    touchObject.curY = (e.touches) ? e.touches[0].pageY : e.clientY
    touchObject.swipeLength = touchObject.curX - touchObject.startX
    var iMoved = iCurrX - this.state.touchObject.curX
    touchObject.curX = iCurrX
    var dayRange = this.state.dayRange
    var touchSlider = {
      touchObject: touchObject
    }
    if(dayRange==5) {
      var swipeMoved = null
      var swipeDirection = this.swipeDirection(touchObject)
      if(swipeDirection === 'left') {
        swipeMoved = this.state.currentPos + iCurrX
      }else if(swipeDirection === 'right') {
        swipeMoved = this.state.currentPos - iCurrX
      }
      touchSlider.touchSliderMove = swipeMoved
    } else{
      touchSlider.touchSliderMove = this.state.currentPos+iMoved
    }
    this.setState(touchSlider)
    e.preventDefault()
  },

  /**
  * Capture end event and then calculate the action desired by the user
  *
  * @param {Object} e event object
  * @returns {undefined} undefined
  **/
  swipeEnd: function () {

    // e.preventDefault()

    if (!this.state.dragging) {
      return
    }

    var touchObject     = this.state.touchObject
    // var minSwipe        = this.state.listWidth/this.props.touchThreshold
    var swipeDirection  = this.swipeDirection(touchObject)

    // reset the state of touch related state variables.
    this.setState({
      dragging: false,
      touchObject: {},
      swipeLength: 0,
      touchSliderMove: this.state.currentPos
    })

    if(swipeDirection === 'left' && Math.abs(touchObject.swipeLength) > 5) {
      this.setState({ didSwipe:true })
      this.previous()
    }else if(swipeDirection === 'right' && Math.abs(touchObject.swipeLength) > 5) {
      this.setState({ didSwipe:true })
      this.next()
    }else if(Math.abs(touchObject.swipeLength) > 1) {
      // micro swipe, not really a click.
      this.reset()
    }else{
      this.reset()
    }

  },

  /**
  * Determines whether the swipe was within a certain angle range and
  * therefore a horizontal swipe rather than a verticle one.
  *
  * @param {Object} touchObject touchObject
  * @returns {String} left/right/vertical
  **/
  swipeDirection: function (touchObject) {

    var xDist = touchObject.startX - touchObject.curX
    var yDist = touchObject.startY - touchObject.curY
    var r = Math.atan2(yDist, xDist)
    var swipeAngle = Math.round(r * 180 / Math.PI)

    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle)
    }
    if ((swipeAngle <= 45) && (swipeAngle >= 0) || (swipeAngle <= 360) && (swipeAngle >= 315)) {
      return (this.props.rtl === false ? 'left' : 'right')
    }
    if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
      return (this.props.rtl === false ? 'right' : 'left')
    }

    return 'vertical'
  },

  /**
  * for performance reasons provide a facility to throttle the updates
  * triggered by mousemove
  *
  * @param {Number} delay time to delay
  * @param {Function} callback function reference which needs to be throttled
  * @returns {Function} Anonymous Function
  **/
  _throttle: function (delay, callback) {
    var previousCall = new Date().getTime()
    return function () {
      var time = new Date().getTime()
      if ((time - previousCall) >= delay) {
        previousCall = time
        callback.apply(null, arguments)
      }
    }
  },

  render: function () {
    var oActiveDates    = this.props.activeDates || {}
    var iDisplayDate    = this.state.displayDate
    var iActiveDate     = this.state.activeDate
    var iOneDay         = this.state.oneDay
    var iDayRange       = this.state.dayRange
    var iItemWidth      = this.state.itemWidth
    // var iSwipeLen       = this.state.touchObject.swipeLength || 0
    var aDayNames       = this.dateDayNamesMedium()
    var iStartDate      = iDisplayDate - (iOneDay * iDayRange)
    var iEndDate        = iDisplayDate + ((iDayRange-1) * iOneDay)
    var aOptNodes       = []
    var showWeek        = this.props.showWeek
    var allDaysActive   = this.props.allDaysActive
    /**
    * Build the date list for the carousel, take the date and build
    * an item for each day X days either side
    **/
    for(var i = 0; i < (iDayRange*3); i++) {

      var iOptDate = iStartDate + (iOneDay * i)
      var iItemPos = iItemWidth*i
      var sActiveClass = ''

      var props = {
        'data-id':  this.dateToKey(iOptDate),
        className:  'day slick-slide', //slick-active
        index:      i,
        style:      { width:iItemWidth+'px' },
        key:        i
      }

      // If allDaysActive is true, all dates get marked as active
      if(!allDaysActive && !oActiveDates[iOptDate]) {
        sActiveClass = 'inactive'
      }

      if(iActiveDate === iOptDate) {
        sActiveClass = 'active'
      }

      /* react will add a span round the first value and the css dosn't want that */
      var oOptDate = this.dateToObject(iOptDate)
      var sDisplayValue = aDayNames[oOptDate.getDay()]+' <span>'+oOptDate.getDate()+'</span>'

      aOptNodes.push((
          <div {...props} onClick={this.selectDate.bind(this,iOptDate,iItemPos)}>
              <a key={'item'+this.dateToKey(iOptDate)} className={sActiveClass} dangerouslySetInnerHTML={{ __html: sDisplayValue }}></a>
          </div>
      ))
    }

    var oSliderprops = {
      onMouseDown:    this.swipeStart,
      onMouseMove:    this.state.dragging ? this._throttle(50,this.swipeMove) : null,
      onMouseUp:      this.swipeEnd,
      onMouseLeave:   this.state.dragging ? this.swipeEnd: null,
      onTouchStart:   this.swipeStart,
      onTouchMove:    this.state.dragging ? this._throttle(50,this.swipeMove) : null,
      onTouchEnd:     this.swipeEnd,
      onTouchCancel:  this.state.dragging ? this.swipeEnd: null,
      className:      'slick-list draggable',
      tabIndex:       0
    }


    var deviceSlider = this.state.dayRange === 5 ? this.state.currentPos : this.state.touchSliderMove
    var oSliderStyle = {
      width:(iItemWidth*(iDayRange*3))+'px',
      left:(deviceSlider + (this.props.centered ? (iItemWidth * Math.floor(iDayRange/2)) : 0)) + 'px'
    }

    var dateStringLarge = (
        <span>
          <span key={'firstDay'} className="firstDay">{this.dateFormat(iDisplayDate - (iOneDay * Math.floor(iDayRange/2)),'date13')} - </span>
          <span key={'lastDay'} className="lastDay">{this.dateFormat(iEndDate - (iOneDay * Math.floor(iDayRange/2)),'date13')}</span>
        </span>
    )

    if ( !this.props.centered ) {
      dateStringLarge = (
        <span>
          <span key={'firstDay'} className="firstDay">{this.dateFormat(iDisplayDate ,'date13')} - </span>
          <span key={'lastDay'} className="lastDay">{this.dateFormat(iEndDate,'date13')}</span>
        </span>
      )
    }

    var dateStringSmall = (
        <span key={'selectedDay'} className="firstDay">{this.dateFormat(iDisplayDate,'date13')}</span>
      )

    if(this.state.animate) {
      oSliderStyle.transition = 'left 0.5s' //'all 1s ease-in-out'
    }
    return (
        <div className="carousel-wrap">
            <div className="carousel-week">
              { showWeek ? dateStringLarge : dateStringSmall }
            </div>
            <div className="date-picker-carousel slick-initialized slick-slider">
                <div {...oSliderprops}>
                    <div className="slick-track" style={oSliderStyle}>
                        {aOptNodes}
                    </div>
                </div>
                <button type="button" data-role="none" className="slick-prev slice-arrow" style={{ display:'block' }} onClick={this.previous}></button>
                <button type="button" data-role="none" className="slick-next slice-arrow" style={{ display:'block' }} onClick={this.next}></button>
            </div>
            <DatePicker date={iDisplayDate} callback={this.selectDate} />
            <div className="carousel-day">
                <span id="sbpDate" className="date"></span>
            </div>
        </div>
    )
  },

  /**
  * Calculates the position of the original display date within the
  * new range of dates so it can create the animation effect
  *
  * @param {Number} iNewDate date
  * @returns {undefined} undefined
  **/
  animateToDate: function (iNewDate) {

    // get the visible range of dates.
    var iDisplayDate    = this.state.displayDate
    var iOneDay         = this.state.oneDay
    var iDayRange       = this.state.dayRange
    var iMinDate        = iNewDate - (iOneDay * iDayRange)
    var iMaxDate        = iMinDate + ((iDayRange*3) * iOneDay)
    var iItemWidth      = this.state.itemWidth
    var iMoveTo         = 0

    if(iDisplayDate >= iMinDate && iDisplayDate <= iMaxDate) {
      // is the original date within the visible range?
      var iDiff = iDisplayDate-iMinDate
      iMoveTo = 0 - (iDiff/iOneDay)*iItemWidth
    }else if(iDisplayDate > iMaxDate) {
      // is it bigger then set moveto to last
      iMoveTo = 0 - (iItemWidth * (iDayRange * 3))
    }else if(iDisplayDate < iMinDate) {
      // is it smaller then set moveto to first
      iMoveTo = 0
    }

    this.setState({
      displayDate:   iNewDate,
      currentPos:    iMoveTo,
      touchSliderMove: iMoveTo,
      animate:       false
    })
  },

  /**
  * Call once we have selected a date
  *
  * @param {Number} iDate date
  * @returns {undefined} undefined
  **/
  dateSelected: function (iDate) {
    if(typeof this.props.callback !== 'undefined') {
      let selectedDate = this.dateFormat(iDate, 'date12')
      this.props.callback(this.dateToObject(iDate), selectedDate)
    }
  },

  /**
  * After the component has drawn reset the position of the slider
  * this will cause the css animation to trigger. The timeout is to
  * force react to re-render else it trys to group the changes into 1
  * update and you won't see the animation
  *
  * @returns {undefined} undefined
  **/
  componentDidUpdate: function () {

    var iDayRange       = this.state.dayRange
    var iItemWidth      = this.state.itemWidth
    var iNewPos         = 0-(iDayRange*iItemWidth)

    if(iNewPos !== this.state.currentPos) {
      setTimeout(function () {
        this.setState({
          currentPos:iNewPos,
          touchSliderMove: iNewPos,
          animate:true
        })
      }.bind(this),1)
    }
  }

})

module.exports = DateSlider



// WEBPACK FOOTER //
// ../app/components/common/DateSlider.jsx